import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	expand: {
		id: 'roadmap.timeline-table-kit.common.dependency.expandable-card.expand',
		defaultMessage: 'Expand',
		description: 'Expand button to show details about a specific dependency',
	},
});
